import { product } from "ramda";

const CSR_ROLES = {
    csr: 'csr',
    superUser: 'superuser',
    sales: 'sales',
    productSuperUser: 'product_superuser'
};

export default CSR_ROLES;
